/* dd-buybox.js — Desert Drip buy box behaviour, moved out of the document (2026-09-17).
   Was three inline <script> blocks re-parsed on every page view: initSplideGallery + moveMediaFeatures
   (snippets/product-media-splide.liquid), the pack-card selector and the .ddx-sub purchase options
   (sections/dd-home-pdp.liquid). Now one cached, deferred asset. The FILE loads once; galleries wire
   per element (is-initialized) and re-wire on shopify:section:load so the theme editor keeps working.
   Pack cards + purchase options only run when a section root carries data-dd-buybox (the homepage buy
   box); the PDP (main-product) keeps its own inline copies. Section ids come from element ids, never
   from Liquid interpolation. */
(function () {
  'use strict';
  if (window.__ddBuybox) return;
  window.__ddBuybox = true;

  /* ---------- gallery (Splide main + thumb rail) ---------- */
  function initSplideGallery(sectionId) {
    var mainSelector = '#MainSlider-' + sectionId;
    var thumbSelector = '#ThumbSlider-' + sectionId;
    var mainEl = document.querySelector(mainSelector);
    var thumbEl = document.querySelector(thumbSelector);
    var gallery = document.querySelector('#Gallery-' + sectionId);
    if (!mainEl || typeof Splide === 'undefined') return;
    if (mainEl.classList.contains('is-initialized')) return;

    var thumbSlider = null;

    // Thumb rail = big square tiles that together fill the exact height of the
    // main image (like the Magna reference). Each tile is sized H/count so they
    // stack edge-to-edge with no wasted gaps, and the column widens to match.
    var thumbCount = parseInt(gallery && gallery.getAttribute('data-media-count'), 10);
    if (!thumbCount && thumbEl) thumbCount = thumbEl.querySelectorAll('.splide__slide').length;
    if (!thumbCount || thumbCount < 1) thumbCount = 1;
    var THUMB_GAP = 8;
    var THUMB_MAX = 120; // cap so a low-image product doesn't crowd the main photo
    var THUMB_MIN = 56;
    var mainWrap = gallery ? gallery.querySelector('.splide-main-wrapper') : null;

    function getMainHeight() {
      var h = mainWrap ? Math.round(mainWrap.getBoundingClientRect().height) : 0;
      return h > 0 ? h : 500;
    }
    function getThumbSize() {
      var size = Math.floor((getMainHeight() - THUMB_GAP * (thumbCount - 1)) / thumbCount);
      return Math.max(THUMB_MIN, Math.min(size, THUMB_MAX));
    }
    function trackHeight(size) {
      return size * thumbCount + THUMB_GAP * (thumbCount - 1);
    }

    var t0 = getThumbSize();
    if (gallery) gallery.style.setProperty('--thumb-col', t0 + 'px');

    if (thumbEl) {
      thumbSlider = new Splide(thumbEl, {
        direction: 'ttb',
        height: trackHeight(t0) + 'px',
        perPage: thumbCount,
        fixedWidth: t0,
        fixedHeight: t0,
        gap: THUMB_GAP,
        isNavigation: true,
        pagination: false,
        arrows: false,
        rewind: true,
        wheel: false,
        breakpoints: {
          749: {
            direction: 'ltr',
            height: 'auto',
            perPage: 1,
            fixedWidth: 64,
            fixedHeight: 64,
            gap: 8,
            arrows: false,
            wheel: false
          }
        }
      });
    }

    // Keep the tiles sized to the main image on desktop; reset on mobile.
    function applyThumbHeight() {
      if (!thumbSlider) return;
      if (window.innerWidth > 749) {
        var size = getThumbSize();
        if (gallery) gallery.style.setProperty('--thumb-col', size + 'px');
        thumbSlider.options = {
          height: trackHeight(size) + 'px',
          perPage: thumbCount,
          fixedWidth: size,
          fixedHeight: size
        };
        thumbSlider.refresh();
      } else if (gallery) {
        gallery.style.removeProperty('--thumb-col');
      }
    }
    window.addEventListener('resize', applyThumbHeight);

    var mainSlider = new Splide(mainEl, {
      type: 'fade',
      rewind: true,
      pagination: true,
      arrows: false,
      speed: 400,
      drag: true
    });

    if (thumbSlider) {
      mainSlider.sync(thumbSlider);
    }

    // Lazy gallery: slides after the first carry their urls in data-splide-lazy*. Splide's own
    // 'nearby' mode loaded every slide on mount under type:'fade', so this loads current +-1 only.
    function ddLoadSlide(i) {
      var sl = mainSlider.Components.Slides.getAt(i); var img = sl && sl.slide.querySelector('img[data-splide-lazy]');
      if (!img) return;
      var ss = img.getAttribute('data-splide-lazy-srcset'); if (ss) img.setAttribute('srcset', ss);
      img.setAttribute('src', img.getAttribute('data-splide-lazy'));
      img.removeAttribute('data-splide-lazy'); img.removeAttribute('data-splide-lazy-srcset');
    }
    function ddLoadNear() { var i = mainSlider.index, n = mainSlider.length; ddLoadSlide(i); ddLoadSlide((i + 1) % n); ddLoadSlide((i - 1 + n) % n); }
    mainSlider.on('mounted moved', ddLoadNear);

    mainSlider.mount();
    if (thumbSlider) {
      thumbSlider.mount();
    }
    if (gallery) {
      gallery.classList.add('is-ready');
    }

    // DD: swap the primary (slide 0) image to match the chosen pack.
    // Fired by the package selector via a 'dd:package-image' CustomEvent.
    var ddFirstMain  = mainEl.querySelector('.splide__slide img');
    var ddFirstThumb = thumbEl ? thumbEl.querySelector('.splide__slide img') : null;
    var ddOrigMainSrc    = ddFirstMain  ? ddFirstMain.getAttribute('src') : '';
    var ddOrigMainSrcset = ddFirstMain  ? ddFirstMain.getAttribute('srcset') : '';
    var ddOrigThumbSrc   = ddFirstThumb ? ddFirstThumb.getAttribute('src') : '';
    document.addEventListener('dd:package-image', function (e) {
      var d = (e && e.detail) || {};
      var reset = d.reset || !d.src;
      if (ddFirstMain) {
        if (reset) {
          ddFirstMain.setAttribute('src', ddOrigMainSrc);
          if (ddOrigMainSrcset) { ddFirstMain.setAttribute('srcset', ddOrigMainSrcset); }
          else { ddFirstMain.removeAttribute('srcset'); }
        } else {
          ddFirstMain.setAttribute('src', d.src);
          ddFirstMain.setAttribute('srcset', d.src);
        }
      }
      if (ddFirstThumb) {
        ddFirstThumb.setAttribute('src', reset ? ddOrigThumbSrc : d.src);
      }
      if (mainSlider) { mainSlider.go(0); }
      if (thumbSlider) { thumbSlider.go(0); }
    });

    mainEl.addEventListener('click', function (e) {
      if (!e.target.closest('img')) return;
      var slides = mainEl.querySelectorAll(
        '.splide__slide:not(.splide__slide--clone) img'
      );
      var imageList = Array.prototype.map.call(slides, function (img) {
        return {
          src: img.src.replace(/_[0-9]+x[0-9]*\./, '_2000x.'),
          alt: img.alt || ''
        };
      });
      if (window.mrkLightbox && imageList.length) {
        window.mrkLightbox.open(imageList, mainSlider.index);
      }
    });

    function goToVariantMedia(variant) {
      if (!variant || !variant.featured_media) return;
      var mediaId = variant.featured_media.id;
      mainEl.querySelectorAll('.splide__slide').forEach(function (slide, index) {
        if (slide.dataset.mediaId == mediaId) {
          mainSlider.go(index);
          if (thumbSlider) {
            thumbSlider.go(index);
          }
        }
      });
    }
    document.addEventListener('variant:change', function (e) {
      goToVariantMedia(e.detail && e.detail.variant);
    });
    document.addEventListener('on:variant:change', function (e) {
      goToVariantMedia(e.detail && e.detail.variant);
    });
    document.addEventListener('variant:changed', function (e) {
      goToVariantMedia(e.detail && e.detail.variant);
    });

    setTimeout(function () {
      mainSlider.refresh();
      if (thumbSlider) {
        thumbSlider.refresh();
        applyThumbHeight();
      }
    }, 300);
  }

  function initGalleries(scope) {
    var roots = (scope || document).querySelectorAll('.splide[id^="MainSlider-"]');
    Array.prototype.forEach.call(roots, function (el) {
      initSplideGallery(el.id.slice('MainSlider-'.length));
    });
  }

  /* ---------- feature row moves under the promo bar on phones ---------- */
  function moveMediaFeatures() {
    var featureRow = document.querySelector('.media-feature-row');
    var promoBar = document.querySelector('.dd-promo-bar');
    var gallery = document.querySelector('.product-media-gallery');
    if (!featureRow || !promoBar || !gallery) return;
    if (window.innerWidth <= 749) {
      if (promoBar.nextElementSibling !== featureRow) {
        promoBar.insertAdjacentElement('afterend', featureRow);
      }
    } else {
      if (!gallery.contains(featureRow)) {
        gallery.appendChild(featureRow);
      }
    }
  }

  /* ---------- pack cards (homepage buy box only, data-dd-buybox) ---------- */
  function initPackCards() {
    var cards = document.querySelectorAll('.dd-package__card');

    // Keep the Subscribe & One-Time prices in sync with the selected pack
    var ddPO = document.querySelector('.dd-purchase-options');
    function ddMoney(cents) { return '$' + (cents / 100).toFixed(2); }
    function ddSyncSubPrices(cents) {
      if (!ddPO || !cents) return;
      var disc = parseFloat(ddPO.dataset.subDiscount || '0');
      var discounted = Math.round(cents - (cents * disc / 100));
      var full = ddPO.querySelector('.dd-po-full');
      var dd = ddPO.querySelector('.dd-po-discounted');
      var ot = ddPO.querySelector('.dd-po-onetime');
      if (full) full.textContent = ddMoney(cents);
      if (dd) dd.textContent = ddMoney(discounted);
      if (ot) ot.textContent = ddMoney(cents);
    }
    // Some packs (e.g. the 8-pack trial) are one-time only — hide Subscribe & force one-time.
    function ddApplyPurchaseRules(card) {
      if (!ddPO) return;
      var subOpt = ddPO.querySelector('.dd-purchase-option--sub');
      var freqRow = ddPO.querySelector('[data-frequency-row]');
      var oneTimeOpt = ddPO.querySelector('.dd-purchase-option--onetime');
      var planInput = ddPO.querySelector('[data-selling-plan-input]');
      var onetimeOnly = card && card.dataset.onetimeOnly === 'true';
      if (onetimeOnly) {
        if (subOpt) {
          subOpt.classList.remove('is-active');
          subOpt.style.display = 'none';
          var subRadio = subOpt.querySelector('input[type="radio"]');
          if (subRadio) subRadio.checked = false;
        }
        if (freqRow) freqRow.classList.add('is-hidden');
        if (oneTimeOpt) {
          oneTimeOpt.classList.add('is-active');
          var otRadio = oneTimeOpt.querySelector('input[type="radio"]');
          if (otRadio) otRadio.checked = true;
        }
        if (planInput) planInput.value = '';
      } else if (subOpt) {
        subOpt.style.display = '';
      }
    }

    Array.prototype.forEach.call(cards, function (card) {
      if (card.dataset.ddWired) return;
      card.dataset.ddWired = '1';
      card.addEventListener('click', function () {
        // Active state
        Array.prototype.forEach.call(cards, function (c) { c.classList.remove('is-active'); });
        this.classList.add('is-active');

        // DD: swap the main gallery image to match the chosen pack
        var ddSwap = this.dataset.swapImage;
        document.dispatchEvent(new CustomEvent('dd:package-image', {
          detail: ddSwap ? { src: ddSwap } : { reset: true }
        }));

        // Variant ID
        var variantId = this.dataset.variantId;

        // Product form input
        var formInput = document.querySelector(
          'form[action*="/cart/add"] input[name="id"]'
        );
        if (formInput) {
          formInput.value = variantId;
          formInput.dispatchEvent(
            new Event('change', { bubbles: true })
          );
        }

        // Price update
        var currentPrice = document.querySelector('.dd-custom-price__current');
        var comparePrice = document.querySelector('.dd-custom-price__compare');
        var newPrice = this.dataset.price;
        var newComparePrice = this.dataset.comparePrice;
        if (currentPrice && newPrice) {
          currentPrice.innerHTML = newPrice;
        }
        var stickyPrice = document.querySelector('.dd-sticky-atc__price');
        if (stickyPrice && newPrice) { stickyPrice.innerHTML = newPrice; }
        if (comparePrice) {
          if (newComparePrice && newComparePrice !== '') {
            comparePrice.innerHTML = newComparePrice;
            comparePrice.style.display = 'inline-flex';
          } else {
            comparePrice.style.display = 'none';
          }
        }
        // Sync subscribe/one-time prices to this pack
        ddSyncSubPrices(parseInt(this.dataset.priceCents, 10));
        // Enforce one-time-only packs (hide Subscribe for the 8-pack trial)
        ddApplyPurchaseRules(this);
      });
    });

    // Sync the cart form + subscribe prices to the pre-selected (active) pack on load
    var activeCard = document.querySelector('.dd-package__card.is-active');
    var cartFormInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (activeCard && cartFormInput && activeCard.dataset.variantId) {
      cartFormInput.value = activeCard.dataset.variantId;
      cartFormInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (activeCard) {
      ddSyncSubPrices(parseInt(activeCard.dataset.priceCents, 10));
      ddApplyPurchaseRules(activeCard);
      var stickyPrice0 = document.querySelector('.dd-sticky-atc__price');
      if (stickyPrice0 && activeCard.dataset.price) { stickyPrice0.innerHTML = activeCard.dataset.price; }
    }

    // DD: if a pack-specific image is pre-selected on load, apply it once the gallery is ready
    if (activeCard && activeCard.dataset.swapImage) {
      var ddSwap0 = activeCard.dataset.swapImage;
      var ddFire0 = function () {
        document.dispatchEvent(new CustomEvent('dd:package-image', { detail: { src: ddSwap0 } }));
      };
      ddFire0();
      setTimeout(ddFire0, 400);
    }
  }

  /* ---------- .ddx-sub purchase options (homepage buy box only, data-dd-buybox) ---------- */
  function initSub() {
    var root = document.querySelector('.ddx-sub'); if (!root) return;
    if (root.dataset.ddWired) return;
    root.dataset.ddWired = '1';
    var disc = parseInt(root.getAttribute('data-discount'), 10) || 30;
    var freq = root.querySelector('.ddx-freq-select');
    var subOpt = root.querySelector('.ddx-opt--sub'), otOpt = root.querySelector('.ddx-opt--ot');
    var TRIAL = '48822075916426';
    function form() { return document.querySelector('form[action*="/cart/add"]'); }
    function money(c) { return '$' + (c / 100).toFixed(2); }
    function activeCard() { return document.querySelector('.dd-package__card.is-active') || document.querySelector('.dd-package__card'); }
    function activeCents() { var a = activeCard(); if (!a) return null; var v = a.getAttribute('data-price-cents'); return v ? parseInt(v, 10) : null; }
    function count() { var a = activeCard(); if (!a) return null; var m = a.textContent.match(/(\d+)\s*(pack|serving)/i); return m ? parseInt(m[1], 10) : null; }
    function type() { var c = root.querySelector('input[name="ddx-buy"]:checked'); return c ? c.value : 'subscribe'; }
    function isTrialActive() { var a = activeCard(); return !!(a && a.getAttribute('data-variant-id') === TRIAL); }
    function applyTrialLock() { var locked = isTrialActive(); if (subOpt) subOpt.style.display = locked ? 'none' : ''; var off = root.querySelector('.ddx-ot-offer'); if (off) off.style.display = locked ? 'block' : 'none'; if (locked) { var s = root.querySelector('input[name="ddx-buy"][value="subscribe"]'); if (s) s.checked = false; var o = root.querySelector('input[name="ddx-buy"][value="onetime"]'); if (o) o.checked = true; } }
    function setPlan(val) { var f = form(); if (!f) return; var i = f.querySelector('input[name="selling_plan"]'); if (!i) { i = document.createElement('input'); i.type = 'hidden'; i.name = 'selling_plan'; f.appendChild(i); } i.value = val || ''; }
    function set(sel, txt) { var e = root.querySelector(sel); if (e) e.textContent = txt; }
    function refresh() {
      applyTrialLock();
      var c = activeCents(), n = count();
      if (c != null) {
        var now = Math.round(c * (100 - disc) / 100);
        set('.ddx-now', money(now)); set('.ddx-was', money(c)); set('.ddx-ot', money(c));
        if (n) { var ps = c / n; set('.ddx-ps-was', money(Math.round(ps))); set('.ddx-ps-now', money(Math.round(ps * (100 - disc) / 100))); set('.ddx-ps-ot', money(Math.round(ps))); }
      }
      var t = type();
      subOpt.classList.toggle('is-active', t === 'subscribe');
      otOpt.classList.toggle('is-active', t === 'onetime');
      setPlan(t === 'subscribe' && freq ? freq.value : ''); var eff = (t === 'subscribe') ? Math.round(c * (100 - disc) / 100) : c; var stk = document.querySelector('.dd-sticky-atc__price'); if (stk && c != null) stk.textContent = money(eff);
    }
    root.addEventListener('change', refresh);
    function styleCards() { var mny = function (c) { return '$' + (c / 100).toFixed(2); }; document.querySelectorAll('.dd-package__card').forEach(function (card) { var cents = parseInt(card.getAttribute('data-price-cents') || '0', 10); if (!cents) return; var m = card.textContent.match(/(\d+)\s*(pack|serving)/i); var n = m ? parseInt(m[1], 10) : 1; var sub = Math.round(cents * 70 / 100); var isTrial = card.getAttribute('data-variant-id') === TRIAL; var b = card.querySelector('b'); if (b && !b.dataset.ddp) { b.dataset.ddp = '1'; b.innerHTML = isTrial ? mny(cents) : '<span class="ddp-sub">' + mny(sub) + '</span> <s class="ddp-once">' + mny(cents) + '</s>'; } var per = card.querySelector('.dd-package__per'); if (per) { per.textContent = mny(Math.round((isTrial ? cents : sub) / n)) + '/serving'; } var sm = card.querySelector('small'); if (sm) sm.style.display = 'none'; var sv = card.querySelector('.dd-package__save'); if (sv) sv.style.display = 'none'; }); }
    function setType(t) { var rb = root.querySelector('input[name="ddx-buy"][value="' + t + '"]'); if (rb) rb.checked = true; refresh(); }
    document.addEventListener('click', function (e) { var card = e.target.closest('.dd-package__card'); if (!card) return; setTimeout(function () { setType(card.getAttribute('data-variant-id') === TRIAL ? 'onetime' : 'subscribe'); styleCards(); }, 45); });
    var trial = document.querySelector('.dd-package__card[data-variant-id="' + TRIAL + '"]');
    if (trial && !trial.querySelector('.ddx-trial')) { var b = document.createElement('span'); b.className = 'ddx-trial'; b.textContent = 'TRY IT'; trial.appendChild(b); }
    var POP = '48822075949194';
    var pop = document.querySelector('.dd-package__card[data-variant-id="' + POP + '"]');
    if (pop) { pop.click(); }
    setType('subscribe');
    styleCards();
    refresh();
    setTimeout(refresh, 250);
  }

  /* ---------- boot: same order the inline blocks had (gallery, pack cards, purchase options) ---------- */
  function boot() {
    initGalleries(document);
    moveMediaFeatures();
    window.addEventListener('resize', moveMediaFeatures);
    if (document.querySelector('[data-dd-buybox]')) {
      initPackCards();
      initSub();
    }
  }
  if (document.readyState === 'loading' || document.readyState === 'interactive') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.splide[id^="MainSlider-"]')) {
      initGalleries(e.target);
    }
  });

  window.initSplideGallery = initSplideGallery;
})();
